/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */

import {CustomerFactory, waitForToken} from "../customer/CustomerFactory";
import {IBaseRequestConfiguration} from "./BaseRequestHandler";

export async function getRequestConfigurationWithToken<P = undefined>(): Promise<IBaseRequestConfiguration<P>> {
  const configuration: IBaseRequestConfiguration<P> = {
    headers: {},
  };

  if (waitForToken()) {
    const customer = await CustomerFactory.getCustomer();
    if (customer.token) {
      configuration.headers!.Authorization = `Bearer ${customer.token}`;
    }
  }

  return configuration;
}
